import * as React from 'react';
import type { SVGProps } from 'react';
const SvgThreatsFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <path
      fill="url(#ThreatsFull_svg__a)"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
      opacity={0.35}
    />
    <path
      fill="url(#ThreatsFull_svg__b)"
      d="M7.619 11.575v3.674c0 5.027 6.803 8.557 7.456 8.557.652 0 7.307-3.528 7.307-8.557v-4.822c0-.218-.045-.429-.128-.623l-5.175 5.678a.105.105 0 0 1-.178-.042l-.58-2.046a.105.105 0 0 0-.192-.024l-3.203 5.492 3.022-9.135a.105.105 0 0 1 .188-.024l1.394 2.129a.105.105 0 0 0 .174.002l2.329-3.449-4.416-1.879a1.58 1.58 0 0 0-1.234 0L8.578 8.978a1.58 1.58 0 0 0-.959 1.45z"
    />
    <defs>
      <linearGradient
        id="ThreatsFull_svg__a"
        x1={24.374}
        x2={-13.126}
        y1={22.031}
        y2={21.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
      <linearGradient
        id="ThreatsFull_svg__b"
        x1={19.614}
        x2={1.157}
        y1={19.177}
        y2={18.85}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#948BFF" />
        <stop offset={1} stopColor="#D4D3FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgThreatsFull;
